import SoldAnnouncement from './SoldAnnouncement';
import FlexGrid from './FlexGrid';
import AdFoxTile from './AdFoxTile';
import AdFoxSplitter from './AdFoxSplitter';
import AdFoxWideScreen from './AdFoxWideScreen';
import SeoText from './SeoText';
import BrandedCover from './BrandedCover';

const Widgest = {
  SoldAnnouncement,
  FlexGrid,
  AdFoxTile,
  AdFoxSplitter,
  AdFoxWideScreen,
  SeoText,
  BrandedCover
};

module.exports = Widgest;



// WEBPACK FOOTER //
// ./src/ui/Widgets/index.js